
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";

@Component({})
export default class ForgotPasswordComponent extends Vue {
  public newpasswordFieldType = "password";
  public confirmpasswordFieldType = "password";
  public confirmPassword = null;
  public newPassword = null;
  public wrongPassword = false;
  public token = null;

  public async changeForgottenPassword() {
      let result = await this.$validator.validateAll();
      if (result) {
        if (this.newPassword === this.confirmPassword) {
          this.$showLoader(true);
          let response = await Axios.post(
            API_STORE.AUTHENTICATION + "changeForgottenPassword",
            {
              token: this.token ? this.token : null,
              userId: !this.$lodash.isEmpty(this.$store.state.sessionObject)
                ? this.$store.state.sessionObject.user._id
                : null,
              newPassword: this.newPassword,
            }
          );
          this.$showLoader(false);
          if(response){
            this.$snotify.success(response.data.message);
            this.$router.push("/login");
          }
        } else {
          this.wrongPassword = true;
        }
      }
  }
  // change the type of password field as text or password
  switchVisibility(fieldType) {
    this[fieldType] = this[fieldType] === "password" ? "text" : "password";
  }

  clearErrMsg() {
    this.wrongPassword = false;
  }

  mounted() {
    if (this.$route.params["token"]) {
      this.token = this.$route.params["token"];
    }
  }
}
